import { render } from "./carouselmap.vue?vue&type=template&id=076bd4c7&scoped=true"
import script from "./carouselmap.vue?vue&type=script&lang=js"
export * from "./carouselmap.vue?vue&type=script&lang=js"

import "./carouselmap.vue?vue&type=style&index=0&id=076bd4c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-076bd4c7"

export default script